/**
 * Normaliza un nombre de persona para display consistente en listas/tablas.
 *
 * Regla: Title Case con partículas hispanas ("de", "del", "la", ...) en
 * minúscula si no son la primera palabra. Preserva tildes y ñ.
 *
 * Sirve para uniformar el display cuando los históricos vienen desordenados
 * (MAYÚSCULAS, minúsculas, mezclados). Reservas nuevas ya se normalizan en
 * backend antes de guardar; este helper cubre los antiguos y cualquier
 * captura que se cuele sin normalización.
 *
 * Ejemplos:
 *   formatNombre("OBED GONZALEZ")          → "Obed Gonzalez"
 *   formatNombre("yanina martinez")        → "Yanina Martinez"
 *   formatNombre("MARIA DEL CARMEN PEREZ") → "Maria del Carmen Perez"
 *   formatNombre("thedys estupiñan")       → "Thedys Estupiñan"
 *   formatNombre("ana-maría lópez")        → "Ana-María López"
 */
const PARTICULAS_MINUSCULA = new Set([
  'de', 'del', 'la', 'las', 'los', 'y', 'e',
  'da', 'das', 'do', 'dos',   // portugués
  'van', 'von',               // apellidos europeos
]);

function capToken(token, esPrimera) {
  if (!token) return token;
  // Guiones internos: capitaliza cada parte
  if (token.includes('-')) {
    return token
      .split('-')
      .map((p, i) => capToken(p, i === 0 && esPrimera))
      .join('-');
  }
  const low = token.toLowerCase();
  if (!esPrimera && PARTICULAS_MINUSCULA.has(low)) {
    return low;
  }
  return token.charAt(0).toUpperCase() + token.slice(1).toLowerCase();
}

export function formatNombre(nombre) {
  if (nombre === null || nombre === undefined) return '';
  const s = String(nombre).replace(/\s+/g, ' ').trim();
  if (!s) return '';
  return s.split(' ').map((t, i) => capToken(t, i === 0)).join(' ');
}

export default formatNombre;
